export function textColor(hexcolor?: string | null) {
  if (!hexcolor) return '#030B20'

  const color = hexcolor.trim().replace(/^#/, '')
  if (color.length !== 6) return '#030B20' // 不正な値はデフォルト

  const r = parseInt(color.slice(0, 2), 16)
  const g = parseInt(color.slice(2, 4), 16)
  const b = parseInt(color.slice(4, 6), 16)

  const luminance = (r * 299 + g * 587 + b * 114) / 1000
  return luminance < 160 ? '#ffffff' : '#030B20'
}

export function darkenColor(hex: string, percent = 30) {
  // # を取り除く
  hex = hex.replace(/^#/, '')

  // 3桁 (#abc) の場合は6桁 (#aabbcc) に変換
  if (hex.length === 3) {
    hex = hex
      .split('')
      .map((c) => c + c)
      .join('')
  }

  const num = parseInt(hex, 16)
  let r = (num >> 16) & 0xff
  let g = (num >> 8) & 0xff
  let b = num & 0xff

  // 指定割合で濃くする（例: 30% → brightnessを70%にする）
  const factor = (100 - percent) / 100
  r = Math.max(0, Math.min(255, Math.floor(r * factor)))
  g = Math.max(0, Math.min(255, Math.floor(g * factor)))
  b = Math.max(0, Math.min(255, Math.floor(b * factor)))

  // HEXに戻す
  return '#' + [r, g, b].map((x) => x.toString(16).padStart(2, '0')).join('')
}
export async function validate(refs: any, name: string = 'provider'): Promise<any> {
  if (refs[name]) {
    return await refs[name].validate()
  }
  return null
}

export function k2c(str: string) {
  return str.replace(/-./g, (match) => match.charAt(1).toUpperCase())
}

export function debounce(func: any, wait: number) {
  let timeout: any
  return function (this: any, ...args: any[]) {
    clearTimeout(timeout)
    timeout = setTimeout(() => func(this, args), wait)
  }
}

export function sanitizeHtml(dirty: string): string {
  const sanitize = require('sanitize-html')

  return sanitize(dirty, {
    allowedTags: ['b', 'i', 'em', 'strong', 'span', 'a', 'p', 'br', 'h1', 'h2', 'h3', 'h4', 'h5', 'div', 'img'],
    allowedAttributes: {
      '*': ['class', 'style'],
      a: ['href', 'name', 'target'],
      img: ['src', 'srcset', 'alt', 'title', 'width', 'height', 'loading']
    }
  })
}

export function getDraftKey(id: string): string {
  return `talk_draft_${id}`
}

export function escapeRegExp(value: string): string {
  return value.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')
}

/**
 * ファイル名として無効な文字をアンダースコアに置換
 * @param filename
 * @returns
 */
export function sanitizeFilename(filename: string): string {
  return filename.replace(/[/\\:*?"<>|]/g, '_')
}
